import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Zap, Clock, Lightbulb, ShieldCheck } from 'lucide-react';
export function IdentitySection() {
  const identities = [{
    icon: <Rocket className="w-8 h-8 text-cyan-400" data-id="element-163" />,
    title: 'Profesional Internacional',
    description: 'Dejas de depender exclusivamente de la economía local. Ahora tienes la capacidad de ofrecer servicios digitales al mundo entero y ser valorado a nivel global.'
  }, {
    icon: <Zap className="w-8 h-8 text-yellow-400" data-id="element-164" />,
    title: 'Máquina de Productividad',
    description: 'La Inteligencia Artificial hace el trabajo pesado por ti en minutos. Al terminar proyectos muchísimo más rápido, puedes atender a más clientes sin agotarte mentalmente.'
  }, {
    icon: <Clock className="w-8 h-8 text-green-400" data-id="element-165" />,
    title: 'Dueño Absoluto de tu Tiempo',
    description: 'Adiós a los horarios de oficina matadores por un sueldo que no rinde. Recuperas el control de tu agenda decidiendo cuándo y dónde trabajas, usando solo tu celular.'
  }, {
    icon: <Lightbulb className="w-8 h-8 text-purple-400" data-id="element-166" />,
    title: 'Experto Sin Título Universitario',
    description: 'No necesitas 5 años de carrera, saber programar, ni hablar inglés perfecto. La IA redacta, diseña y traduce; tú solo te conviertes en el director estratégico.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-blue-500" data-id="element-167" />,
    title: 'Economía a Prueba de Crisis',
    description: 'Te proteges de la inflación dominando la habilidad más demandada de la década. Tu conocimiento ahora tiene valor en el extranjero, asegurando la tranquilidad de tu familia.'
  }];
  return <section className="py-24 relative overflow-hidden bg-[#050505]" data-id="element-168">
      {/* Elementos decorativos de fondo */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-cyan-600/5 blur-[120px] rounded-full pointer-events-none" data-id="element-169" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-171">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-6 backdrop-blur-sm" data-id="element-172">
            <span className="w-2 h-2 rounded-full bg-cyan-500 shadow-[0_0_10px_#06b6d4] animate-pulse" data-id="element-173"></span>
            <span className="text-xs font-bold text-gray-300 tracking-widest uppercase" data-id="element-174">Tu Evolución Digital</span>
          </motion.div>

          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tight leading-tight" data-id="element-175">
            CONVIÉRTETE EN UN <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600 drop-shadow-[0_0_15px_rgba(6,182,212,0.3)]" data-id="element-176">PROFESIONAL GLOBAL</span>
          </h2>
          <p className="text-gray-400 text-lg md:text-xl font-light max-w-2xl mx-auto leading-relaxed" data-id="element-177">
            No es solo una herramienta, es tu pasaporte para empezar a trabajar con clientes internacionales sin tener que salir de casa ni invertir en equipos caros.
          </p>
        </motion.div>

        <div className="grid gap-6" data-id="element-178">
          {identities.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          delay: index * 0.15
        }} className="group flex flex-col md:flex-row items-start md:items-center gap-6 p-6 md:p-8 rounded-2xl bg-white/[0.03] border border-white/5 hover:border-cyan-500/30 hover:bg-white/[0.06] hover:shadow-[0_0_30px_rgba(6,182,212,0.1)] transition-all duration-300 relative overflow-hidden" data-id="element-179">
              {/* Brillo de fondo sutil al pasar el mouse */}
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/0 via-cyan-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-180" />

              {/* Icono con fondo brillante */}
              <div className="relative flex-shrink-0 z-10" data-id="element-181">
                <div className="absolute inset-0 bg-cyan-500/20 blur-xl rounded-full group-hover:bg-cyan-500/40 transition-colors duration-300" data-id="element-182" />
                <div className="relative p-4 rounded-xl bg-[#0f172a] border border-white/10 group-hover:border-cyan-500/50 group-hover:scale-110 transition-all duration-300" data-id="element-183">
                  {item.icon}
                </div>
              </div>

              {/* Textos */}
              <div className="flex-1 z-10" data-id="element-184">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2 group-hover:text-cyan-300 transition-colors" data-id="element-185">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed font-light" data-id="element-186">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}